import { team } from 'ducks/entities/schema'

export const teamApiV1ResponseSchema = {
  group: team,
}
